export default "__VITE_ASSET__04fcf2e9__"